module.exports = __webpack_public_path__ + "img/23.e26eb2c2.jpg";